<template>
  <div class="modal fade" id="modal-mobile-version">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header" style="text-align:center">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">{{$t('mobile.app_description')}}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="description">{{$t('mobile.app_name')}}</label>
                <p>{{ applicationData.name }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="description">{{$t('mobile.os_name')}}</label>
                <p>{{ osData.name }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <label for="description" class="col-md-12">{{$t('mobile.version')}}</label>
            <div class="col-md-4">
              <div class="form-group">
                <label for="email">{{$t('mobile.version_major')}}</label>
                <input type="number" class="form-control" v-model="versionData.major">
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label for="email">{{$t('mobile.version_minor')}}</label>
                <input type="number" class="form-control" v-model="versionData.minor">
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label for="email">{{$t('mobile.version_build')}}</label>
                <input type="number" class="form-control" v-model="versionData.build">
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <!-- status button -->
          <lte-button
            id="status-private"
            :right_icon="'fa fa-lock'"
            type="button"
            class="btn btn-primary pull-right"
            @click="onSaveVersion"
          >&nbsp;{{$t('common.save')}}</lte-button> <!-- status button -->

          <!-- save answer button -->
          <lte-button
            type="button"
            class="btn btn-dark pull-left"
            @click="closeModal"
          >{{$t('common.close')}}</lte-button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script>
// import { mapGetters, mapActions } from "vuex";
import LTEButton from "./LTEButton.vue";

export default {
  name: 'lte-modal',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      applicationData: {
        id: 0,
        code: "",
        name: "",
        description: ""
      },
      versionData: {
        id: 0,
        name: "",
        major: "",
        minor: "",
        build: "",
        isActive: false,
        other_details: ""
      },
      osData: {
        id: "",
        name: ""
      },
      styleObject: {
        default : "modal-default",
        danger  : "modal-danger",
        info    : "modal-info",
        warning : "modal-warning",
        success : "modal-success"
      },
      iconObject: {
        danger  : "fa-ban",
        info    : "fa-info",
        warning : "fa-warning",
        success : "fa-check"
      }
    }
  },
  methods: {
    closeModal: function() {
      $("#modal-mobile-version").modal("hide");
    },
    onConfirm: function () {
      this.$emit('onConfirm')
    },
    getStyle: function(style) {
      let cls = this.styleObject[style];
      return {
        cls: cls
      }
    },
    onSaveVersion: function() {
      let data = {
        id: this.versionData.id,
        major: this.versionData.major,
        minor: this.versionData.minor,
        build: this.versionData.build,
        isActive: this.versionData.isActive,
        other_details: this.versionData.other_details,

        application: this.applicationData.id,
        operation_system: this.osData.id
      }
      this.$emit('onSaveVersion', data);
    }
  },

  watch: {
    item: function() {
      this.applicationData.name = this.item.app_name;
      this.applicationData.id = this.item.app_id;
      this.osData.name = this.item.os_name;
      this.osData.id = this.item.os_id;

      if (this.item.latest_version == null) {
        this.versionData.major = 0;
        this.versionData.minor = 0;
        this.versionData.build = 0;
      } else {
        this.versionData.major = this.item.latest_version.major;
        this.versionData.minor = this.item.latest_version.minor;
        this.versionData.build = this.item.latest_version.build;
      }
    }
  },

  mounted() {

  },

  components: {
    "lte-button": LTEButton
  }
}

</script>

<style lang="scss" scoped>
  .modal {
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/MobileVersionModal.vue